module.exports = __webpack_public_path__ + "img/clipboard.ef7bca3b.svg";